module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray"
  }, [_c('backTitleBar'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-btn click"
  }, [_vm._v("确定")]), _vm._v(" "), _c('img', {
    staticClass: "scan-img click",
    attrs: {
      "src": _vm.scan_img,
      "alt": ""
    },
    on: {
      "click": _vm.scan
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "text-center pd-250 fs-28 color-999"
  }, [_vm._v("请输入核销码")]), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "type": "number"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05bdded5","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/order/verification.vue
// module id = 0Lpf
// module chunks = 51